module.exports = __webpack_public_path__ + "img/prev_inactive.adc4cee2.png";